// extracted by mini-css-extract-plugin
export default {"container":"FP-z","title":"GP-z","link":"HP-z"};